import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/blog`)
      .then((r) => setPosts(r.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  return (
    <section id="journal" data-testid="blog-preview-section" className="py-24 lg:py-32 bg-[#F4F1EB]">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.28em] text-[#B35B47]">— The Journal</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#2C302E] leading-[1.05]">
              Notes from the<br />quiet path.
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="inline-flex items-center gap-2 text-sm text-[#2C302E] border-b border-[#2C302E]/40 pb-0.5 hover:text-[#B35B47] hover:border-[#B35B47] transition-colors"
          >
            Read all articles <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {posts.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block"
              >
                <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-[#EAE5D9]">
                  <img
                    src={p.cover_image}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                </div>
                <div className="mt-5 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#8A8D86]">
                  <span className="text-[#B35B47]">{p.tag}</span>
                  <span>·</span>
                  <span>{p.read_time}</span>
                </div>
                <h3 className="font-serif text-2xl lg:text-[1.7rem] mt-3 text-[#2C302E] group-hover:text-[#B35B47] transition-colors">
                  {p.title}
                </h3>
                <p className="mt-3 text-[#5C605A] line-clamp-2">{p.excerpt}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
